import styled from '@emotion/styled';

const ButtonWrapper = styled('div')({
  display: 'flex',
});

export default ButtonWrapper;
